<template>
    <modal :show="showModal" @close="closeModal">
        <div class="invite-modal">
            <h2>Invite a Bill Payer</h2>

            <div class="input-block">
                <label for="first-name">First Name</label>
                <input id="first-name" maxlength="50" name="first_name" placeholder="e.g. John" type="text"
                       v-model="fields.first_name">
                <span class="input-requirement error" v-text="errors.get('first_name')"></span>
            </div>

            <div class="input-block">
                <label for="last-name">Last Name</label>
                <input id="last-name" maxlength="50" name="last_name" placeholder="e.g. Smith" type="text"
                       v-model="fields.last_name">
                <span class="input-requirement error" v-text="errors.get('last_name')"></span>
            </div>

            <div class="input-block">
                <label for="national-number">Mobile Number</label>
                <telephone-input placeholder="e.g. 7700 900123" v-model="fields.phone_number"></telephone-input>
                <span class="input-requirement error" v-text="errors.get('phone_number')"></span>
            </div>

            <button :disabled="isLoading" @click="saveUser" class="btn btn-primary" type="button">
                Add bill payer
                <fa-spinner v-show="isLoading"/>
            </button>

        </div>
    </modal>
</template>

<script>
    import store from "../../../store/index";
    import Errors from '../../../helpers/Errors';

    import Modal from '../../Modal';
    import TelephoneInput from "../../telephoneinput/TelephoneInput";
    import FaSpinner from "../../FaSpinner";

    export default {
        name: "InviteModal",

        components: {
            FaSpinner,
            Modal,
            TelephoneInput,
        },

        data() {
            return {
                isLoading: false,
                fields: {
                    first_name: '',
                    last_name: '',
                    phone_number: {
                        formatted: '',
                        country_code: '',
                        national_number: ''
                    },
                },
                errors: new Errors()
            }
        },

        mounted() {
            this.$store.watch((state) => state.invite.activeInviteHousemate, (index) => {
                if (index !== null) {
                    this.loadUser();
                }
            })
        },

        methods: {
            closeModal() {
                store.commit('invite/hideInviteModal');
                this.$data.errors.wipe();
                this.emptyInputs();
            },

            emptyInputs() {
                this.$data.fields.first_name = '';
                this.$data.fields.last_name = '';
                this.$data.fields.phone_number.country_code = '';
                this.$data.fields.phone_number.national_number = '';
            },

            async verifyUser() {
                // Refresh error messages
                this.$data.errors.wipe();

                if (!this.$data.fields.first_name) {
                    this.$data.errors.create('first_name', 'First name is required.');
                }

                if (!this.$data.fields.last_name) {
                    this.$data.errors.create('last_name', 'Last name is required.');
                }

                if (!this.$data.fields.phone_number.national_number) {
                    this.$data.errors.create('phone_number', 'Phone number is required.');
                }

                let alpha_regex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;

                if (!this.$data.fields.first_name.match(alpha_regex)) {
                    this.$data.errors.create('first_name', 'First name must be letters.');
                }

                if (!this.$data.fields.last_name.match(alpha_regex)) {
                    this.$data.errors.create('last_name', 'Last name must be letters.');
                }

                if (this.$data.fields.phone_number.national_number) {
                    try {
                        const response = await axios.get(
                            '/onboarding/validate-number',
                            {params: {number: this.$data.fields.phone_number.country_code + this.$data.fields.phone_number.national_number,}}
                        );
                        this.$data.fields.phone_number.formatted = response.data;
                    } catch (e) {
                        this.$data.errors.create('phone_number', 'Phone number is not valid.');
                    }
                }

                return _.size(this.$data.errors.all()) === 0;
            },

            loadUser() {
                let current = this.$store.getters['invite/getActiveUser'];

                if (!_.isEmpty(current)) {
                    this.$data.fields = _.cloneDeep(current);
                }
            },

            async saveUser() {
                this.isLoading = true;
                if (await this.verifyUser()) {
                    store.commit('invite/addUser', _.cloneDeep(this.$data.fields));
                    this.closeModal();
                }
                this.isLoading = false
            }
        },

        computed: {
            showModal() {
                return this.$store.getters['invite/getShowInviteModal'];
            },
        }
    }
</script>
